/**
 * Кастомная иконка «Друзья / Сообщество» для нижнего меню
 *
 * fill="black" заменён на currentColor для поддержки окрашивания через Tailwind
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function CommunityIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3944 12.3563C17.2744 12.3563 16.2233 12.5874 15.3391 12.9792C18.4337 13.8935 20.6244 16.0836 20.6834 18.6456C22.2945 18.4346 24.0333 17.8117 24.0333 16.1138C24.0333 14.0743 21.4496 12.3563 18.3944 12.3563Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3652 10.9097H18.3848C20.4774 10.9097 22.1867 9.16152 22.1867 7.03163C22.1867 4.89168 20.4774 3.14355 18.3848 3.14355C17.9722 3.14355 17.5793 3.21388 17.206 3.33444C17.8838 4.3592 18.2768 5.59495 18.2768 6.93116C18.2866 8.28746 17.874 9.59353 17.0979 10.6786C17.5007 10.8293 17.9231 10.9097 18.3652 10.9097Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.71786 12.9692C7.8337 12.5874 6.78253 12.3563 5.67242 12.3563C2.61716 12.3563 0.0334473 14.0743 0.0334473 16.1138C0.0334473 17.8117 1.76247 18.4245 3.3736 18.6456C3.42272 16.0836 5.61347 13.8935 8.71786 12.9692Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.67243 10.9097H5.7019C6.14398 10.9097 6.56642 10.8293 6.9692 10.6786C6.22258 9.63372 5.7805 8.3377 5.7805 6.93116C5.7805 5.59495 6.17346 4.3592 6.85131 3.33444C6.478 3.21388 6.08504 3.14355 5.67243 3.14355C3.57992 3.14355 1.88037 4.89168 1.88037 7.03163C1.88037 9.16152 3.57992 10.9097 5.67243 10.9097Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0282 14.0011C8.13697 14.0011 4.84888 16.1672 4.84888 18.7311C4.84888 22.0465 10.2521 22.0465 12.0282 22.0465C15.111 22.0465 19.2096 21.7049 19.2096 18.7522C19.2096 16.1762 15.9205 14.0011 12.0282 14.0011Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0291 11.8199H12.0615C13.3337 11.8159 14.5283 11.3045 15.4243 10.3812C16.3212 9.45795 16.8124 8.23326 16.8075 6.93423C16.8075 4.2387 14.6649 2.04651 12.0291 2.04651C9.39432 2.04651 7.25171 4.2387 7.25171 6.93423C7.25171 9.62774 9.39432 11.8199 12.0291 11.8199Z"
        fill="currentColor"
      />
    </svg>
  );
}